import Modal from 'flarum/common/components/Modal';
import CompatHistory from './CompatHistory';

/**
 * A board row's history, over the page: the reader stays on the front page
 * and closes it to carry on. The row still has a real href, so a middle- or
 * ctrl-click opens the /compatibility/:slug page in a new tab instead.
 */
export default class CompatModal extends Modal {
  className() {
    return 'BnCompatModal Modal--large';
  }
  title() {
    return this.attrs.product;
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(CompatHistory, {
      slug: this.attrs.slug
    }));
  }
}
flarum.reg.add('blizznux-home', 'forum/components/CompatModal', CompatModal);